import { render, staticRenderFns } from "./FacilityItem.vue?vue&type=template&id=bddb4356"
import script from "./FacilityItem.vue?vue&type=script&lang=js"
export * from "./FacilityItem.vue?vue&type=script&lang=js"
import style0 from "./FacilityItem.vue?vue&type=style&index=0&id=bddb4356&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports